export const isClientPortalHost = (hostname = window.location.hostname) =>
  ["web.millergroup.it", "web.localhost"].includes(hostname.toLowerCase());

export function portalPath(path, hostname = window.location.hostname) {
  const base = isClientPortalHost(hostname) ? "" : "/AreaClienti";
  if (path === undefined) return base || "/";
  return `${base}/${path.replace(/^\/+/, "")}`;
}
